
/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import KanbanCard from "layouts/applications/kanban/components/Card";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Box, Icon, Modal, Theme, useMediaQuery } from "@mui/material";
import { eraseRichText, getUUIDFromKey, shuffle } from 'utils/helpers';
import { Link, useLocation } from 'react-router-dom';
import { Howl } from 'howler'
import './styles.css'
import linearGradient from 'assets/theme/functions/linearGradient';
import Logo from '../../../assets/images/logo.svg'
import { getCardCollectionById } from 'services/card-collection-services';

import { v4 } from 'uuid';
import Board from '@asseinfo/react-kanban';
import MDButton from 'components/MDButton';
import { QuestionValidator } from 'components/QuestionValidator';
import { SendInvitationProps } from 'types';
import { useCognito } from 'services/cognito-service';
import MDInput from 'components/MDInput';
import { notifyError } from 'services/quiz-services';
import { Hexagon, HexGrid, Layout, Pattern } from 'react-hexgrid';
import validator from 'validator';
import { Auth } from 'aws-amplify';
import Loader from 'components/Loader';
import { useAppContext } from 'context/app-context';

const style = {
  maxWidth: 400,
  minWidth: 300,
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'auto',
  maxHeight: 'calc(100vh - 100px)',
  overflowY: 'auto',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

interface ICard {
  id: string;
  template: JSX.Element;
}

interface IColumn {
  id: string;
  title: string;
  cards: ICard[];
}
interface IBoard {
  columns: IColumn[];
}

const colors = ["#ffe12a", "#f54c5b", "#cb6efe", "#8fdc9c", "#00b9f8", "#ff8445"];
function PlayQuizzes(): JSX.Element {

  const [pk, setPk] = useState<string>('')
  const [quiz, setQuiz] = useState<{
    title: string,
    grade: string,
    description: string,
    category: {
      name: string,
      subject: string
    },
    subcategory: {
      name: string
    },
    answer: string,
    descriptionAudio?: string
    answerAudio?: string
    descriptionImage: string
    answerImage: string
  }>(null)
  const [playingDescriptionSound, setPlayingDescriptionSound] = useState(false);
  const [comment, setComment] = useState('')
  const [playingAnswerSound, setPlayingAnswerSound] = useState(false);
  const [descriptionSound, setDescriptionSound] = useState<Howl>({} as Howl)
  const [answerSound, setAnswerSound] = useState<Howl>({} as Howl)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [seeAnswer, setSeeAnswer] = useState<boolean>(false)
  const [seeAnimation, setSeeAnimation] = useState(true)
  const [subCategories, setSubCategories] = useState([])
  const [quizzes, setQuizzes] = useState([])

  const location = useLocation()
  const { signedIn } = useCognito()

  useEffect(() => {
    if (location.hasOwnProperty('pathname')) {
      const list = location.pathname.split('/')
      const { [list.length - 1]: pathname } = list
      setPk(`CARDCOLLECTION#${pathname}`)
    }
  }, [location])

  // useEffect(() => {
  //   if (pk && signedIn) {
  //     (async () => {
  //       setSortIndexes((await getPlaySessionByCardCollectionId(getUUIDFromKey(pk))).indexes)
  //     })()
  //   }
  // }, [pk, signedIn])

  useEffect(() => {
    if (pk && ((signedIn === true) || signedIn === false)) {
      (async () => {
        const quizzes = await getCardCollectionById(getUUIDFromKey(pk))
        const mappedQuizzes = Object.entries(quizzes)//@ts-ignore
          .sort((a, b) => a.values.index - b.values.index)
          .map((s) => [s[0], {
            ...s[1], quizzes: signedIn ? s[1].quizzes : s[1].quizzes//.slice(0, 15)
          }])
          .map((s) => ({
            ...s[1], quizzes: shuffle(s[1].quizzes)
          }))
        // if (mappedQuizzes.map(x => x.quizzes?.length).reduce((acc, curr) => acc + curr, 0))
        setQuizzes(JSON.parse(JSON.stringify([...mappedQuizzes])))
        console.log({ mappedQuizzes: mappedQuizzes.map(x => x.quizzes.length) })
      })()
    }
  }, [pk, signedIn])

  useEffect(() => {
    setSubCategories([...JSON.parse(JSON.stringify([...quizzes]))])
  }, [quizzes])

  const { handleMessage} = useAppContext()

  useEffect(() => {
    if (quiz?.descriptionAudio)
      setDescriptionSound(new Howl({
        src: quiz.descriptionAudio,
        html5: true,
        onend: function () {
          setPlayingDescriptionSound(false)
        },
      }))

  }, [quiz?.descriptionAudio])

  useEffect(() => {
    if (quiz?.answerAudio) {
      setAnswerSound(new Howl({
        src: quiz?.answerAudio,
        html5: true,
        onend: function () {
          setPlayingAnswerSound(false)
        },
      }))
    }
  }, [quiz?.answerAudio])


  const handleDescriptionSound = (): void => {
    setPlayingDescriptionSound(!playingDescriptionSound)
    try {
      if (!playingDescriptionSound) {
        descriptionSound.play()
      } else {
        descriptionSound.stop()
      }
    } catch (error) {
      handleMessage("Der er ingen lyd til denne quiz", 'info')
    }
  }

  const handleAnswerSound = (): void => {
    setPlayingAnswerSound(!playingAnswerSound)
    try {
      if (!playingAnswerSound) {
        answerSound.play()
      } else {
        answerSound.stop()
      }
    } catch (error) {
      handleMessage("Der er ingen lyd til denne quiz", 'info')
    }
  }

  const [boards, setBoards] = useState<IBoard>({
    columns: [
      {
        //@ts-ignore
        id: "column1", key: v4(), title: "", cards: [],
      },
    ],
  });

  useEffect(() => {
    if (subCategories.length) {
      setBoards({
        columns: [{
          id: 'column1',
          title: '',
          cards: subCategories.map((c, index) => ({
            ...c,
            id: c.PK,
            template: <KanbanCard
              hasAudio={false}
              hasPicture={false}
              key={c.PK}
              badge={{ color: colors[index], label: "" }}
              content={c.name}
              members={[]}
            />
          }))
        }]
      })
    }
  }, [subCategories])
  const desktop = useMediaQuery('(min-width:481px)')
  const [open, setOpen] = useState(false)

  const handleSubmit = async () => {
    const quizInfo = {}
    Object.assign(quizInfo, {
      grade: quiz?.grade,
      subject: quiz?.category.subject,
      category: quiz?.category?.name,
      subCategory: quiz?.subcategory?.name,
      title: quiz?.title
    })
    const question = {}

    if (quiz?.description) {
      Object.assign(question, { description: quiz?.description })
    }

    if (quiz?.descriptionImage) {
      Object.assign(question, { descriptionImage: quiz?.descriptionImage })
    }

    if (quiz?.descriptionAudio) {
      Object.assign(question, { descriptionAudio: quiz?.descriptionAudio })
    }
    Object.assign(quizInfo, { question })

    const answer = {}

    if (quiz?.answer) {
      Object.assign(answer, { answer: quiz?.answer })
    }

    if (quiz?.answerImage) {
      Object.assign(answer, { answerImage: quiz?.answerImage })
    }

    if (quiz?.answerAudio) {
      Object.assign(answer, { answerAudio: quiz?.answerAudio })
    }
    Object.assign(quizInfo, { answer })

    const data = { quizInfo, comment } as SendInvitationProps
    try {
      await notifyError(data)
      setOpen(!open)
    } catch (error) {
      //@ts-ignore
      handleMessage(error?.response?.data?.message || error?.message, 'error')
    }
  }

  const handleSignIn = async () => {
    setIsLoading(true)
    try {
      if (!validator.isEmail(email)) {
        handleMessage('Brug din registrerede e-mail', 'error')
        return
      }
      try {
        await Auth.signIn(email, password)
        setIsLoading(false)
      } catch (error) {
        setIsLoading(false)
        //@ts-ignore
        handleMessage(error?.response?.data?.message || error?.message, 'error')
      }
    } catch (error) {
      setIsLoading(false)
      //@ts-ignore
      if (error.code === 'UserNotConfirmedException') {
        if (email && password) {
          //@ts-ignore
          handleMessage(error?.response?.data?.message || error.message, 'error')

        }
        //@ts-ignore
      } else if (error.code === 'NotAuthorizedException') {
        //@ts-ignore
        //@ts-ignore
        handleMessage(error?.response?.data?.message || error.message, 'error')
      } else {
        throw error
      }
    }
  }

  return (
    <>
      {isLoading ? <Loader /> :
        <DashboardLayout>
          <DashboardNavbar />
          <Card style={{ position: 'relative', padding: !desktop ? -24 : 0 }}>
            <MDBox style={{ zIndex: 9 }} py={desktop ? 3 : 1} flex={1} lineHeight={1}>
              <MDBox
                display={!desktop && 'flex'}
                flexDirection={!desktop ? 'row' : 'unset'}
                justifyContent={!desktop ? 'space-between' : 'unset'}
                alignItems={!desktop ? 'center' : 'unset'}
              >
              {!signedIn && <Link to='authentication/sign-in'>
                  <MDButton style={{
                    marginLeft: desktop ? 40 : 0,
                    marginRight: desktop ? 0 : 16,
                  }} color='warning'>Log ind</MDButton>
                </Link>}
              </MDBox>
              <MDBox
                marginTop='20px'
                marginRight='auto'
                marginLeft='auto'
                minWidth={'320px'}
                maxWidth={'100%'}
                width={desktop ? 400 : "100%"}
                height={760}
                bgColor={linearGradient('#7030A0', '#00B0F0', 0)}
                py={3}
                px={3}
                sx={({
                  palette: { light, background },
                  functions: { pxToRem },
                  borders: { borderRadius },
                }: Theme | any) => ({
                  "& .react-kanban-column": {
                    display: 'block',
                    // flex: 1,
                    width: '100%',
                    // padding: pxToRem(20),
                    borderRadius: borderRadius.lg,
                  },
                })}
                position='relative'
                borderRadius='5rem'
                border={`.5em solid white`}
                boxShadow='0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19) !important'
              >
                {subCategories.length ? <MDBox
                  // minWidth={'fit-content'}
                  heigh='100%'
                >
                  {quiz ? <>
                    <MDBox
                      display='flex'
                      justifyContent='center'>
                      <MDTypography align='center' marginTop={0} variant='h3' color='white' fontWeight='bold'>{quiz.title}</MDTypography>
                    </MDBox>
                    <div
                      style={{
                        paddingTop: 20,
                        paddingBottom: 20,
                        width: '100%',
                        color: 'white',
                        display: 'flex',
                        marginBottom: 15,
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        paddingLeft: 15,
                        paddingRight: 15,
                        textAlign: 'start',
                      }}
                      dangerouslySetInnerHTML={
                        { __html: quiz.description?.replaceAll(/&nbsp;/g,' ') as string }
                      } />
                    {quiz.descriptionImage &&
                      <>
                        <Zoom>
                          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
                            <img
                              style={{
                                maxWidth: 300,
                                maxHeight: 250,
                                width: "auto"
                              }}
                              alt="quiz img"
                              src={quiz.descriptionImage}
                            />
                          </div>
                        </Zoom>
                      </>}
                    {quiz?.descriptionAudio && <>
                      <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <MDButton onClick={() => handleDescriptionSound()} iconOnly><Icon fontSize='large'>{playingDescriptionSound ? 'stop' : 'play_arrow'}</Icon></MDButton>
                      </div>
                    </>}
                    <div style={{ display: 'block', height: 250 }}>
                      {!seeAnswer ?
                        (
                          <div>
                            <div className="button" onClick={() => setSeeAnswer(true)} style={{ position: 'relative' }}>

                              <MDTypography className='text' variant="h5" fontWeight="medium">
                                <span style={{ color: '#FFFFFF' }}>Tjek svar</span>
                              </MDTypography>

                            </div>
                          </div>

                        )
                        :
                        seeAnimation ? <QuestionValidator
                          setSeeAnimation={setSeeAnimation} correct={true} /> :
                          (
                            <>
                              <div style={{
                                height: "80%",
                                marginBottom: 15,
                                marginTop: 15,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                flexWrap: 'wrap'
                              }}>
                                {eraseRichText(quiz?.answer || '') && <div
                                  style={{
                                    height: 'fit-content',
                                    marginBottom: 10,
                                    width: '100%',
                                    color: 'white',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    textAlign: 'start',
                                  }}
                                  dangerouslySetInnerHTML={
                                    { __html: quiz.answer.replaceAll(/&nbsp;/g,' ') }
                                  } />}
                                <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                                  {quiz.answerImage && <Zoom >
                                    <img
                                      height='30%'
                                      style={{ maxWidth: 200, maxHeight: 145, width: "auto" }}
                                      alt="quiz img"
                                      src={quiz.answerImage}
                                    />
                                  </Zoom>}
                                  {quiz?.answerAudio && <>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                      <MDButton onClick={() => handleAnswerSound()} iconOnly><Icon fontSize='large'>{playingAnswerSound ? 'stop' : 'play_arrow'}</Icon></MDButton>
                                    </div>
                                  </>}
                                </div>
                              </div>
                            </>
                          )}
                    </div>
                  </>
                    :
                    <Board
                      disableCardDrag
                      disableColumnDrag
                      allowAddCard
                      renderColumnHeader={({ id, title }: any) => (
                        <>
                          <MDBox
                            key={id}
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            mb={3}>
                            <MDTypography variant="h4">{title}</MDTypography>
                          </MDBox>
                        </>
                      )}
                      renderCard={({ id, template }: any, { dragging }: any) => (
                        <MDBox
                          onClick={() => {
                            const index = subCategories.findIndex(sub => sub.PK === id)
                            const subCategory = subCategories[index]
                            // console.log(subCategory)
                            if (quizzes[index].quizzes?.length) {
                              if (subCategory.quizzes.length) {
                                // console.log('not shuffling')
                                console.log(subCategory.quizzes.length)
                                const currentQuiz = subCategory.quizzes.shift()
                                console.log(currentQuiz)
                                console.log(subCategory.quizzes.length)
                                Object.assign(currentQuiz, { grade: subCategory.grade, subcategory: subCategory, category: subCategory.category })
                                setQuiz(currentQuiz)
                              } else {
                                // console.log('shuffling')
                                const shuffledQuizzes = JSON.parse(JSON.stringify(shuffle(quizzes[index].quizzes)))
                                // console.log(shuffledQuizzes)
                                const currentQuiz = shuffledQuizzes.shift()
                                setQuiz(currentQuiz)
                                Object.assign(subCategory.quizzes, shuffledQuizzes)
                              }
                              subCategories.splice(index, 1, subCategory)
                              setSubCategories([...subCategories])
                            } else {
                              handleMessage('Der er ikke noget spørgsmål til denne quiz endnu', 'info')
                            }
                          }}
                          key={id}
                          dragging={dragging.toString() || undefined}
                          display="flex"
                          maxWidth='calc(100%)'
                          width='100%'
                          height={desktop ? "100%" : 'calc(100% - 100px)'}
                          bgColor="white"
                          color="text"
                          borderRadius="xl"
                          mt={desktop ? 2.5 : 1}
                          py={desktop ? 1.875 : 1}
                          px={1.875}
                          lineHeight={1.5}
                          sx={{
                            cursor: 'pointer',
                            textOverflow: 'ellipsis',
                            border: 0,
                            fontSize: ({ typography: { size } }: any) => size['2xl'],
                            color: ({ palette: { black } }) => black.main,
                          }}
                        >
                          {template}
                        </MDBox>
                      )}
                    >
                      {boards}
                    </Board>}
                </MDBox> : null}
                <MDBox
                  style={{
                    cursor: quiz ? 'pointer' : 'default'
                  }}
                  onClick={() => {
                    setQuiz(null)
                    setSeeAnimation(true)
                    setSeeAnswer(false)
                  }}

                  marginTop={subCategories.length ? 2 : 0} display={'flex'} justifyContent={'center'}><img style={{ position: 'absolute', bottom: 0 }} src={Logo} alt='logo' /></MDBox>
              </MDBox>

            </MDBox >
            <div style={{
              overflow: 'hidden',
              transform: 'translateY(-200px)'
            }}>
              <Modal
                open={open}
                onClose={() => setOpen(!open)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  {signedIn ? <div>
                    <p> <span style={{ color: '#518eb9', fontSize: 28, fontWeight: 'bold' }}>Klassetrin:</span> {quiz?.grade}</p>
                    <p> <span style={{ color: '#518eb9', fontSize: 28, fontWeight: 'bold' }}>Fag:</span> {quiz?.category.subject} </p>
                    <p> <span style={{ color: '#518eb9', fontSize: 28, fontWeight: 'bold' }}>Hovedkategori:</span> {quiz?.category?.name}</p>
                    <p> <span style={{ color: '#518eb9', fontSize: 28, fontWeight: 'bold' }}>Quiz-kategori:</span> {quiz?.subcategory?.name}</p>
                    <p> <span style={{ color: '#518eb9', fontSize: 28, fontWeight: 'bold' }}>Titel:</span> {quiz?.title}</p>
                    <p> <span style={{ color: '#518eb9', fontSize: 28, fontWeight: 'bold' }}>Spørgsmål:</span> </p>
                    {eraseRichText(quiz?.description || '') && <div style={{ marginLeft: 35 }}><span>Beskrivelse:</span> <div dangerouslySetInnerHTML={
                      { __html: quiz?.description.replaceAll(/&nbsp;/g,' ') as string }
                    }></div></div>}
                    {quiz?.descriptionImage && <div style={{ marginLeft: 35 }}><span>Image Description:</span> <Zoom><img width={100} src={quiz?.descriptionImage} alt='description' /> </Zoom>  </div>}
                    {quiz?.descriptionAudio && <div style={{ marginLeft: 35 }}><span>Audio Description:</span><MDButton onClick={() => handleDescriptionSound()} iconOnly><Icon fontSize='large'>{playingDescriptionSound ? 'stop' : 'play_arrow'}</Icon></MDButton></div>}
                    <p> <span style={{ color: '#518eb9', fontSize: 28, fontWeight: 'bold' }}>Svar:</span> </p>
                    {eraseRichText(quiz?.answer || '') && <div style={{ marginLeft: 35 }}><span>Beskrivelse:</span> <div dangerouslySetInnerHTML={
                      { __html: quiz?.answer.replaceAll(/&nbsp;/g,' ') as string }
                    }></div></div>}
                    {quiz?.answerImage && <div style={{ marginLeft: 35 }}><span>Image Answer:</span> <Zoom><img width={100} src={quiz?.answerImage} alt='answer' /> </Zoom>  </div>}
                    {quiz?.answerAudio && <div style={{ marginLeft: 35 }}><span>Audio Answer:</span><MDButton onClick={() => handleAnswerSound()} iconOnly><Icon fontSize='large'>{playingAnswerSound ? 'stop' : 'play_arrow'}</Icon></MDButton></div>}
                    {/* <MDBox
                      display='flex'
                      gap={10}
                      alignItems='start'
                    > */}
                      <MDInput value={comment} onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setComment(e.target.value)} fullWidth label="Beskriv fejlen her..." multiline rows={5} />
                      <MDButton style={{marginTop: 15}} color='info' onClick={() => handleSubmit()} fullWidth>Indsend</MDButton>
                    {/* </MDBox> */}
                  </div>
                    : <>
                      <MDTypography variant='h3' color='info'>Få din lærer til at logge ind og anmelde denne fejl</MDTypography>
                      <MDTypography variant='h3' marginTop={5} textAlign='center'>Log ind</MDTypography>
                      <MDBox
                        gap={4}
                        paddingX={2}
                        paddingY={5}
                        display='flex'
                        flexDirection='column'
                      >
                        <MDInput style={{ maxWidth: 300}} label="E-mail" value={email} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)} ></MDInput>
                        <MDInput style={{ maxWidth: 300}} label="Adgangskode" value={password} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)} type='password'></MDInput>
                        <MDButton fullWidth style={{ maxWidth: 300}} onClick={handleSignIn} color='success'>Log ind</MDButton>
                      </MDBox>
                    </>
                  }
                </Box>
              </Modal>
              <MDBox
                // width={'100vw'}
                height='fit-content'
                py={10}
                paddingTop={0}
              >
                <MDBox
                  width='100%'
                  overflowX='hidden'
                  textAlign='center'
                  display='flex'
                  justifyContent='center'
                >
                  <HexGrid id="SVG" width={3000} height={470} viewBox="-50 -50 100 100">
                    <Layout size={{ x: 13, y: 13 }} flat={true} spacing={1.1} origin={{ x: 0, y: 0 }}>
                      <Hexagon q={-12} r={7} s={1} fill="pat-3" />
                      <Hexagon q={-11} r={6} s={1} fill="pat-4" />
                      <Hexagon q={-10} r={6} s={1} fill="pat-5" />
                      <Hexagon q={-9} r={5} s={1} fill="pat-6" />
                      <Hexagon q={-8} r={5} s={1} fill="pat-1" />
                      <Hexagon q={-7} r={5} s={1} fill="pat-2" />
                      <Hexagon q={-6} r={4} s={1} fill="pat-3" />
                      <Hexagon q={-5} r={4} s={1} fill="pat-4" />
                      <Hexagon q={-4} r={3} s={1} fill="pat-5" />
                      <Hexagon q={-3} r={2} s={1} fill="pat-6" />
                      <Hexagon q={-2} r={2} s={1} fill="pat-1" />
                      <Hexagon q={-1} r={1} s={1} fill="pat-2" />
                      <Hexagon q={0} r={0} s={1} fill="pat-3" />
                      <Hexagon q={1} r={0} s={0} fill="pat-4" />
                      <Hexagon q={2} r={0} s={0} fill="pat-5" />
                      <Hexagon q={3} r={-1} s={0} fill="pat-6" />
                      <Hexagon q={4} r={-1} s={0} fill="pat-1" />
                      <Hexagon q={5} r={-1} s={0} fill="pat-2" />
                      <Hexagon q={6} r={-2} s={0} fill="pat-3" />
                      <Hexagon q={7} r={-2} s={0} fill="pat-4" />
                      <Hexagon q={8} r={-3} s={0} fill="pat-5" />
                      <Hexagon q={9} r={-4} s={0} fill="pat-6" />
                      <Hexagon q={10} r={-4} s={0} fill="pat-1" />
                      <Hexagon q={11} r={-5} s={0} fill="pat-2" />
                      <Hexagon q={12} r={-5} s={0} fill="pat-3" />
                      <Pattern id="pat-1" link="https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/site-documents/Sp%C3%B8rgsma%CC%8AlNY2.png-1.png" size={{ x: 13, y: 11 }} />
                      <Pattern id="pat-2" link="https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/site-documents/Sp%C3%B8rgsma%CC%8AlNY2.png-2.png" size={{ x: 13, y: 11 }} />
                      <Pattern id="pat-3" link="https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/site-documents/Sp%C3%B8rgsma%CC%8AlNY2.png-3.png" size={{ x: 13, y: 11 }} />
                      <Pattern id="pat-4" link="https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/site-documents/Sp%C3%B8rgsma%CC%8AlNY2.png-4.png" size={{ x: 13, y: 11 }} />
                      <Pattern id="pat-5" link="https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/site-documents/Sp%C3%B8rgsma%CC%8AlNY2.png-5.png" size={{ x: 13, y: 11 }} />
                      <Pattern id="pat-6" link="https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/site-documents/Sp%C3%B8rgsma%CC%8AlNY2.png-6.png" size={{ x: 13, y: 11 }} />
                    </Layout>
                  </HexGrid>
                </MDBox>
              </MDBox>
              {seeAnswer && <div
                style={{
                  fontSize: 30,
                  transform: 'translateY(-200px)',

                  textAlign: 'center'
                }}>Fejl på dette kort?
                <br /> <span style={{
                  cursor: 'pointer',
                  color: '#518eb9'
                }} onClick={() => { setOpen(true) }} >Klik her</span>
              </div>}
            </div>
          </Card >
        </DashboardLayout >
      }</>
  );
}


export default PlayQuizzes;